export default {
    indexEstablishments:    { method: 'get',    url: 'establishments' },
    createEstablishment:    { method: 'post',   url: 'establishments'},
    updateEstablishment:    { method: 'put',    url: 'establishments/{id}'},
    deleteEstablishment:    { method: 'delete', url: 'establishments/{id}'}
}